module.exports = ".grid-container {\n  margin: 20px;\n}\n"